export default __webpack_public_path__ + "static/media/C0001.d53be654.png";